import { combineWords } from '../../../util/formatters';
import { employeeName } from '../../utils/employee-name';

export const surveyRecipients = (survey: Survey) => {
  const wasSentToNoEmployees =
    survey.wasCreatedWithNoRecipients &&
    survey.EmployeeGroupRecipients.length === 0 &&
    survey.EmployeeRecipients.length === 0;
  const wasSentToAllEmployees =
    !survey.wasCreatedWithNoRecipients &&
    survey.EmployeeGroupRecipients.length === 0 &&
    survey.EmployeeRecipients.length === 0;

  if (wasSentToNoEmployees) {
    return 'No Employees';
  }
  if (wasSentToAllEmployees) {
    return 'All Employees';
  }

  // Otherwise, build a string which is `${groupNames}, and ${employeeNames}`
  const recipients: Array<string> = [];
  if (survey.EmployeeGroupRecipients.length > 0) {
    survey.EmployeeGroupRecipients.forEach((egr) => recipients.push(egr.name));
  }
  if (survey.EmployeeRecipients.length > 0) {
    survey.EmployeeRecipients.slice(0, 3).forEach((er) => recipients.push(employeeName(er)));
  }
  if (survey.EmployeeRecipients.length > 3) {
    const numberOfOthers = survey.EmployeeRecipients.length - 3;
    recipients.push(`${numberOfOthers} more`);
  }
  return combineWords(recipients);
};
